<p qpxCell="secondary" variant="sm">
    {{ message() }}
</p>

@if (canPublish()) {
    <button
        qpxButton
        matButton="outlined"
        size="sm"
        (click)="onPublishBuildingRequested()"
    >
        <ng-icon qpx name="lucideCloudUpload" matButtonIcon />
        <span>Publish building</span>
    </button>
}
